import { insertProspectFromTender } from '../../services/clients';
import { insertTenderQuoteTask } from '../../services/dealActivities';
import { upsertDealLines } from '../../services/dealLines';
import { insertDealFromTender } from '../../services/deals';
import { markTenderUnderReview } from '../../services/tenders';
import { notify } from '../../store/feedback';
import { dealLineToRow } from '../../utils/dealLinesDb';
import { uid } from '../../utils/format';
import { tenderBudgetLines } from './dealLineDefaults';

/* Conversion d'un appel d'offres en affaire, avec création du prospect si besoin. */
export default function tenderToDealHandlers(deps) {
  const { deals, closeModal, form, modalData, session, setDeals, setTenders, setCrmClients } = deps;

  async function convertTenderToDeal() {
    const n = modalData.notice;
    const f = form;
    if (!f.nom || !f.nom.trim()) {
      notify("Le nom de l'affaire est requis.");
      return;
    }
    let clientId = f.clientMode === 'existing' ? f.client_id || null : null;
    if (f.clientMode === 'new') {
      if (!f.newClientNom || !f.newClientNom.trim()) {
        notify('Nom du prospect requis.');
        return;
      }
      const newClientId = uid();
      const { error } = await insertProspectFromTender(f, newClientId);
      if (error) {
        notify('Erreur création du prospect : ' + error.message);
        return;
      }
      setCrmClients((prev) => [
        ...prev,
        {
          id: newClientId,
          nom: f.newClientNom.trim(),
          statut: 'prospect',
          secteurs: f.newClientSecteurs || [],
        },
      ]);
      clientId = newClientId;
    }
    const dealId = uid();
    const maxOrdre = deals.reduce((mx, a) => Math.max(mx, a.ordre || 0), 0);
    const { error: affError } = await insertDealFromTender(dealId, clientId, f, maxOrdre, n);
    if (affError) {
      notify("Erreur création de l'affaire : " + affError.message);
      return;
    }
    const lignes = tenderBudgetLines(f.nom.trim(), f.budget_estime);
    if (lignes.length) await upsertDealLines(dealId, dealLineToRow, lignes);
    if (n.date_limite) {
      await insertTenderQuoteTask(dealId, n, session);
    }
    const { error: qualError } = await markTenderUnderReview(n);
    if (qualError)
      notify('Affaire créée, mais erreur mise à jour du statut AO : ' + qualError.message);
    setDeals((list) => [
      ...list,
      {
        id: dealId,
        nom: f.nom.trim(),
        client_id: clientId,
        statut: 'a_travailler',
        type_projet: f.type_projet || null,
        boamp_idweb: n.idweb,
        lignes,
      },
    ]);
    setTenders((list) =>
      list.map((x) => (x.idweb === n.idweb ? { ...x, qualification_status: 'a_instruire' } : x)),
    );
    closeModal();
  }

  return { convertTenderToDeal };
}
